import { useDroppable } from "@dnd-kit/core"
import { Card, CardContent } from "design-system/molecules/Card"
import { cn } from "design-system/utils"
import { Plus } from "lucide-react"
import { NEW_CANONICAL_TOPIC_DROP_ZONE_ID } from "../../lib/canonicalTopics/constants"

export const NewCanonicalTopicDropZone = () => {
  const { setNodeRef, isOver } = useDroppable({
    id: NEW_CANONICAL_TOPIC_DROP_ZONE_ID,
  })

  return (
    <Card
      ref={setNodeRef}
      className={cn(
        "w-full flex flex-col border-2 border-dashed transition-all duration-200 shrink-0 p-4",
        isOver
          ? "border-primary bg-primary/10 shadow-md"
          : "border-muted-foreground/30 hover:border-muted-foreground/50",
      )}
    >
      <CardContent className="flex-1 flex items-center justify-center p-2">
        <div className="flex flex-row items-center gap-4 text-left">
          <div
            className={cn(
              "rounded-full p-3 transition-colors",
              isOver ? "bg-primary/20" : "bg-muted",
            )}
          >
            <Plus
              className={cn(
                "h-6 w-6 transition-colors",
                isOver ? "text-primary" : "text-muted-foreground",
              )}
            />
          </div>
          <div className="flex flex-col justify-start gap-1">
            <div
              className={cn(
                "text-sm font-medium",
                isOver ? "text-primary" : "text-muted-foreground",
              )}
            >
              {"Create new canonical topic"}
            </div>
            <div className="text-xs text-muted-foreground">
              {"Drop a snapshot here to create a new topic"}
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
